import React, { useState, useEffect } from "react";
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import { Login } from "./Pages/Login";
import { Cadastro } from "./Pages/Cadastro";
import { Home } from "./Pages/Home";
import { AlterarCadastro } from "./Pages/AlterarCad";
import { Enviados } from "./Pages/Enviados";
import { Configuracao } from "./Pages/Configuracao";
import { CameraPage } from "./Pages/CameraPage";
import { QrCodePage } from './Pages/QrCodePage';
import ProtectedRoute from './ProtectedRoute';

const Rotas = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Cadastro />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Cadastro" element={<Cadastro />} />
        <Route path="/CameraPage" element={<CameraPage />} />
        <Route path="/QrCodePage/:id" element={<QrCodePage />} />

        {/* Grupo de rotas protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/Home" element={<Home />} />
          <Route path="/AlterarCadastro" element={<AlterarCadastro />} />
          <Route path="/Enviados" element={<Enviados />} />
          <Route path="/Configuracoes" element={<Configuracao />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Rotas;
